import {FormGroup} from "@angular/forms";

const clearFormFields = (form: FormGroup, ...args: string[]) : void => {
    if (args?.length) {
      args.forEach((field) => {
        form.controls[field].reset();
      });
    } else {
        form.reset();
    }
}

export default clearFormFields;